import { type InvitedUser } from '../types/user';

export const categoriseSelectedMembers = (selectedMembers: InvitedUser[]) => {
	const newUsersWhoNeedInvite: InvitedUser[] = [];
	const existingUsers: InvitedUser[] = [];

	selectedMembers.forEach((selectedMember) => {
		if (!selectedMember.email && selectedMember.fullName === selectedMember.id) {
			newUsersWhoNeedInvite.push(selectedMember);
			return;
		}

		existingUsers.push(selectedMember);
	});

	return { newUsersWhoNeedInvite, existingUsers };
};
